import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppPermissionService } from '../../../../core/services/app-permission.service';
import { ContentHeaderComponent } from '../../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../../shared/components/title-functionbar/title-functionbar.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { AuftragSucheComponent } from '../../auftrag/auftrag-suche/auftrag-suche.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-batch-auftrag-suche',
  templateUrl: './batch-auftrag-suche.component.html',
  styleUrls: ['./batch-auftrag-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    AuftragSucheComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class BatchAuftragSucheComponent implements OnInit {
  searchMode: string;

  hasDatenexportAuftragAdminRight;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    permissionService: AppPermissionService
  ) {
    this.hasDatenexportAuftragAdminRight = permissionService.hasPermission('DATENEXPORT_AUFTRAG_ADMIN');
  }

  ngOnInit() {
    this.searchMode = 'searchAuftrag';
  }

  onNew() {
    this.router.navigate(['new'], {
      relativeTo: this.route
    });
  }
}
